import React, { useState } from 'react';
import Popup from 'reactjs-popup';
import axios from 'axios';

const ModalModifyClient = ({ isVisible, onClose, listServer, choosenClient }) => {
    
    let token = localStorage.getItem("token");
    const [values, setValues] = useState({
        id_cli: '',
        nom: '',
        date_pose: '',
        date_limite: '',
        nb_ecrans: '',
        serveur: '',
        color: '',
        remarque: '',
        id:''
    })

    const handleClose = (e) => {
        if (e.target.id === "wrapper") onClose();
    }

    if (choosenClient.id_cli !== values.id_cli) setValues({ ...values, ...choosenClient })

    const headers = {
        'x-access-token': token,
        'Content-Type': 'application/json'
    };
    const deleteClient = (e) => {
        e.preventDefault();
        let data = {
            id: values.id_cli
        }
        console.log(data);
        axios.delete(`${process.env.REACT_APP_IP}:${process.env.REACT_APP_PORT}/delete_client`,{headers, data})
        .then((res) => {
                console.log(res);
                window.location.reload(false);
            }).catch(err => console.log(err))
        
    }
    const handleSubmit = (e) => {
        e.preventDefault();
        let error = document.getElementById('error');
        error.innerHTML = '';
        if(values.nom === '' || values.date_pose === '' || values.date_limite === '' || values.nb_ecrans === ''){
            error.innerHTML = "Veuillez renseigner tout les champs"
        }else{
           values.id = values.id_cli
           values.date_pose = new Date(values.date_pose).toLocaleDateString("fr").split("/").reverse().join("-")
           values.date_limite = new Date(values.date_limite).toLocaleDateString("fr").split("/").reverse().join("-")
            axios.post(`${process.env.REACT_APP_IP}:${process.env.REACT_APP_PORT}/update_client`, values)
            .then(res => {
                console.log(res);
                // navigate('/listusers');
                window.location.reload(false);
            }).catch(err => console.log(err))
        }
    }
    function formatDateClient(datePose) {
        let newdate = new Date(datePose)
        let month = newdate.getMonth() + 1 > 9 ? newdate.getMonth() + 1 : `0${newdate.getMonth() + 1}`
        let day = newdate.getDate() > 9 ? newdate.getDate() : `0${newdate.getDate()}`
        let formatDate = `${newdate.getFullYear()}-${month}-${day}`
        return formatDate;
    }

    const close = () => {
        let divTooltip = document.getElementById('popup-2');
        divTooltip.style.display = "none"
    }
    
    if (!isVisible) return null;
    return (
        <div className='fixed inset-0 z-50 flex items-center justify-center bg-slate-900/50 backdrop-blur-sm p-4' id="wrapper" onClick={handleClose}>
            <div className='bg-white rounded-2xl shadow-2xl w-full max-w-lg max-h-[85vh] overflow-y-auto'>
                <div className="flex items-center justify-between border-b border-slate-200 px-6 py-4">
                    <h2 className="text-lg font-semibold text-slate-800">Modifier le client</h2>
                    <button type="button" className='flex h-8 w-8 items-center justify-center rounded-lg text-slate-400 hover:bg-slate-100 hover:text-slate-600' onClick={() => onClose()}>✕</button>
                </div>
                <form className="p-6" onSubmit={handleSubmit}>
                    <div className="mb-4">
                        <label htmlFor="nom" className="mb-1 block text-xs font-semibold uppercase tracking-wide text-slate-500">Nom</label>
                        <input type="text" name="nom" id="nom" className="w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm text-slate-800 focus:border-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500/30" placeholder="Nom" required onChange={e => setValues({ ...values, nom: e.target.value })} value={values.nom} />
                    </div>
                    <div className="mb-4">
                        <label htmlFor="nb_ecrans" className="mb-1 block text-xs font-semibold uppercase tracking-wide text-slate-500">Nombre d'écrans</label>
                        <input type="text" name="nb_ecrans" id="nb_ecrans" className="w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm text-slate-800 focus:border-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500/30" placeholder="Nombre d'écrans" required onChange={e => setValues({ ...values, nb_ecrans: e.target.value })} value={values.nb_ecrans} />
                    </div>
                    <div className="mb-4">
                        <label htmlFor="date_pose" className="mb-1 block text-xs font-semibold uppercase tracking-wide text-slate-500">Date de pose</label>
                        <input type="date" name="date_pose" id="date_pose" className="w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm text-slate-800 focus:border-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500/30" placeholder=" " required onChange={e => setValues({ ...values, date_pose: e.target.value })} value={formatDateClient(values.date_pose)} />
                    </div>
                    <div className="mb-4">
                        <label htmlFor="date_limite" className="mb-1 block text-xs font-semibold uppercase tracking-wide text-slate-500">Date limite</label>
                        <input type="date" name="date_limite" id="date_limite" className="w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm text-slate-800 focus:border-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500/30" placeholder=" " required onChange={e => setValues({ ...values, date_limite: e.target.value })} value={formatDateClient(values.date_limite)} />
                    </div>
                    <div className="mb-4">
                        <label htmlFor="serveur" className="mb-1 block text-xs font-semibold uppercase tracking-wide text-slate-500">Serveur</label>
                        <select id="serveur" className="w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm text-slate-800 focus:border-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500/30" onChange={e => setValues({ ...values, serveur: e.target.value })} value={values.serveur}>
                            {
                                listServer.map((server) => (
                                    <option value={server.id}>{server.nom_serveur}</option>
                                ))
                            }
                        </select>
                    </div>
                    <div className="mb-4">
                        <label htmlFor="remarque" className="mb-1 block text-xs font-semibold uppercase tracking-wide text-slate-500">Remarque (optionnel)</label>
                        <textarea name="remarque" id="remarque" className="w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm text-slate-800 focus:border-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500/30" placeholder="Remarque (optionnel)" onChange={e => setValues({ ...values, remarque: e.target.value })} value={values.remarque} />
                    </div>
                    <div className='flex justify-between'>
                        <button type="submit" className="rounded-lg bg-indigo-500 px-4 py-2 text-sm font-medium text-white hover:bg-indigo-600">Enregistrer</button>
                        <Popup trigger=
                            {<button type="button" className="rounded-lg bg-red-600 px-4 py-2 text-sm font-medium text-white hover:bg-red-700" > Supprimer </button>}
                            position="right center">
                            <div>Est-ce votre dernier mot?</div>
                            <div className="flex justify-between gap-2 mt-2">
                                <button type="button" className="rounded-lg bg-indigo-500 px-3 py-2 text-sm font-medium text-white hover:bg-indigo-600" onClick={deleteClient}> Accepter </button>
                                <button type="button" className="rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm font-medium text-slate-700 shadow-sm hover:bg-slate-50" onClick={close}> Annuler </button>
                            </div>
                        </Popup>
                    </div>
                    <div className="py-4 text-center">
                        <p id="error" className='text-red-600'></p>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default ModalModifyClient;